import { useSelfcare } from "modules/selfcare/hooks/useSelfcare";

export function useRoles() {
  const { data } = useSelfcare(false);
  return { roles: data?.roles, routes: data?.routes };
}
